import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DeliveryTermsController } from './delivery-terms.controller';
import { DeliveryTerms } from './delivery-terms.entity';
import { DeliveryTermsService } from './delivery-terms.service';
import { DeliveryTermsAdapter } from './dto/delivery-terms.adapter';

@Module({
  imports: [
    TypeOrmModule.forFeature([DeliveryTerms]),
  ],
  controllers: [DeliveryTermsController],
  providers: [DeliveryTermsService,DeliveryTermsAdapter,ApplicationExceptionHandler,LogsService]
})
export class DeliveryTermsModule {}
